<template>
  <div v-if="orderId" class="qr notranslate">
    <div class="mt30">{{ locale.reservation_check_qrcode }}</div>
    <vue-qrcode v-if="value"
      :value="value"
      :scale="scale || 6" />
  </div>
</template>

<script>
import VueQrcode from 'vue-qrcode'

export default {
  name: 'ReservationQrcode',
  props: [
    'locale',
    'lang',
    'ln',
    'scale',
    'orderId'
  ],
  components: {
    VueQrcode
  },
  async created () {
    const orderId = this.orderId
    const getOta = await this.$store.dispatch('authentication/getOtaKey')
    const authInfo = this.$store.getters['authentication/getAuthInfo']
    if (orderId && authInfo && authInfo.site) {
      const value = {
        siteId: authInfo.site,
        orderUUID: orderId,
        ...authInfo.rid && {
          rid: authInfo.rid
        },
        ...authInfo.k && {
          ota: authInfo.k
        }
      }
      this.value = JSON.stringify(value)
    } else {

    }
  },
  data () {
    return {
      value: null
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.qr {
  padding-left: 30px;
  padding-right: 30px;
  text-align: center;
}
</style>
